export default __webpack_public_path__ + "static/media/02.17461010.webp";